export interface Exercise {
  id: string;
  name: string;
  description?: string;
  metric: ExerciseMetric;
  created: Date;
  modified?: Date;

  // LATER: body part [], equipment []
  // deleted field (soft delete)
  // NOTE: should there be ref check when deleting an exercise (e.g. activities)
}

export enum ExerciseMetric {
  weight,
  time,
}

export const exerciseMetricToString = (metric: ExerciseMetric): string =>
  metric === ExerciseMetric.weight ? 'Weight' : 'Time';
